// extracted by mini-css-extract-plugin
export var number = "Sv0-ktDU";